var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("Webheader.tracking"),
        "show-filter": _vm.tabName === 1 || _vm.tabName === 2,
        "show-refresh": _vm.tabName === 1 || _vm.tabName === 2,
        "show-extract": _vm.showExportButton,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
        "extract-disabled": _vm.activateSpinner,
      },
      on: {
        "toggle-filter": _vm.toggleFilter,
        refresh: _vm.refreshCurrentTab,
        extract: _vm.exportCurrentTab,
      },
    },
    [
      _vm.tabName === 1 || _vm.tabName === 2
        ? _c(
            "template",
            { slot: "filterContent" },
            [
              _c("app-panel", {
                attrs: {
                  filters: _vm.currentFilterConfig,
                  searchAriaLabel: _vm.searchAriaLabel,
                },
                on: {
                  "filter-changed": _vm.onFilterChanged,
                  "clear-filters": _vm.clearCurrentFilters,
                  "apply-filters": _vm.applyCurrentFilter,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type != "BULKDETAILS" && !_vm.flagTOOLBOX
        ? _c("template", { slot: "navigationTabs" }, [
            _c("div", { staticClass: "d-block d-lg-none" }, [
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                _vm._l(_vm.tabs, function (tab, index) {
                  return _c("app-button", {
                    key: index,
                    attrs: {
                      text: _vm.$t(tab.translationKey),
                      variant: _vm.tabName === tab.value ? "primary" : "light",
                      size: "md",
                      block: true,
                      "custom-class": "mb-2",
                      role: "tab",
                      id: "mobile-tab-" + _vm.randomId + "-" + tab.value,
                      "aria-selected":
                        _vm.tabName === tab.value ? "true" : "false",
                      "aria-controls":
                        "tabpanel-" + _vm.randomId + "-" + tab.value,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeTabName(tab.value)
                      },
                    },
                  })
                }),
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-none d-lg-block" }, [
              _c(
                "div",
                {
                  staticClass: "nav nav-tabs nav-fill border-0",
                  attrs: { role: "tablist" },
                },
                _vm._l(_vm.tabs, function (tab, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      class: [
                        "nav-link",
                        {
                          "active bg-primary text-white font-weight-bold":
                            _vm.tabName === tab.value,
                        },
                      ],
                      attrs: {
                        id: "desktop-tab-" + _vm.randomId + "-" + tab.value,
                        role: "tab",
                        type: "button",
                        "aria-selected":
                          _vm.tabName === tab.value ? "true" : "false",
                        "aria-controls":
                          "tabpanel-" + _vm.randomId + "-" + tab.value,
                        tabindex: _vm.tabName === tab.value ? "0" : "-1",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeTabName(tab.value)
                        },
                        keydown: function ($event) {
                          return _vm.handleTabKeydown($event, tab.value)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(tab.translationKey)) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c(
              "nav",
              {
                staticClass: "sr-only",
                attrs: { "aria-label": _vm.$t("tracking.breadcrumb") },
              },
              [
                _c("ol", [
                  _c("li", [_vm._v(_vm._s(_vm.$t("Webheader.tracking")))]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "requestsList" }, [
              _c("div", { staticClass: "mt-0" }, [
                _c("div", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tabName === 1,
                          expression: "tabName === 1",
                        },
                      ],
                      attrs: {
                        role: "tabpanel",
                        id: "tabpanel-" + _vm.randomId + "-1",
                        "aria-labelledby": "desktop-tab-" + _vm.randomId + "-1",
                        "aria-hidden": "false",
                      },
                    },
                    [
                      _c("TrackingList", {
                        attrs: {
                          type: _vm.TrackType,
                          id: _vm.id,
                          filters: _vm.trackingFilters,
                          "vop-provider-list": _vm.vopProviderList,
                          "display-filter": _vm.displayFilter,
                        },
                        on: {
                          "update-tab": function (val) {
                            return (_vm.trackingFilters.tabName = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.flagCACP
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tabName === 2,
                              expression: "tabName === 2",
                            },
                          ],
                          attrs: {
                            role: "tabpanel",
                            id: "tabpanel-" + _vm.randomId + "-2",
                            "aria-labelledby":
                              "desktop-tab-" + _vm.randomId + "-2",
                            "aria-hidden": _vm.tabName !== 2 ? "true" : "false",
                          },
                        },
                        [
                          _c("TrackingBulkPage", {
                            ref: "bulk",
                            attrs: {
                              filters: _vm.bulkFilters,
                              "display-filter": false,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }